import { useEffect, ReactNode } from 'react';

// Import components
import { Loader } from 'components/elements';

// Import hooks
import { useAppSelector, useAppDispatch } from 'store/hooks';

// Import actions
import { fetchSubscriberDetails } from 'store/features/subscriber/thunk';

type Props = {
	children: ReactNode;
};

export const SubscriberTemplate = ({ children }: Props) => {
	const dispatch = useAppDispatch();
	const isLoading = useAppSelector(({ subscriber }) => subscriber.token && !subscriber.details);

	useEffect(() => {
		if (isLoading) {
			dispatch(fetchSubscriberDetails());
		}
	}, []);

	return isLoading ? <Loader /> : children;
};
